import axios from 'axios';
import store from '@/store/index';

const Admin = {
     async getRoles() {
          return await axios({
               method: 'GET',
               url: process.env.VUE_APP_API_URI + '/roles',
          });
     },
     async inviteUsers(users) {
          return await axios({
               method: 'POST',
               url: process.env.VUE_APP_API_URI + '/user-invite',
               data: users,
          });
     },
     async getOrgMembers() {
          return await axios({
               method: 'GET',
               url: process.env.VUE_APP_API_URI + '/organizations',
          });
     },
};

export default Admin;
